module.exports = {
  PORT: "4047",
  NODE_ENV: "production",

  SERVER_DEV_URL: "http://localhost:3131",
  SERVER_STAGING_URL: "https://esgprojectaward-api.cloudxier.dev", // example "https://golfngroove-api.cloudxier.dev"
  SERVER_PROD_URL: "https://api.esgprojectaward.com", // example "https://golfngroove-api.cloudxier.com"

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: "esgprojectaward.cloudxier.dev", // example "golf-event.netlify.app"
  CLIENT_PROD_HOST: "esgprojectaward.com", // "example golfngroove.bigevent.id"

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: "https://esgprojectaward.cloudxier.dev", // example https://golf-event.netlify.app
  CLIENT_PROD_URL: "https://esgprojectaward.com", // example https://golfngroove.bigevent.id

  MAIN_WEBSITE_TITLE: 'ESG | ', // example 'GNG | '
  SITE_NAME: 'Project Awards' // example 'Golf N Groove'
}
